import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "影视资讯", to: "/category/film-news" },
  { label: "娱乐新闻", to: "/category/entertainment-news" },
  { label: "电影推荐", to: "/category/movie-recommend" },
  { label: "电视剧更新", to: "/category/tv-update" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-3-fill text-background-50 text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                红桃网
              </span>
            </div>
            <p className="text-sm text-primary-200/90 leading-relaxed max-w-md">
              红桃网是面向影视爱好者的资讯与娱乐内容分享平台，聚合最新影视资讯、娱乐新闻、电影推荐与电视剧更新，帮助你及时掌握影视娱乐动态。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-qq-fill"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-primary-100 hover:bg-primary-800 transition-colors cursor-pointer"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200/90 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于与联系
            </h4>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200/90 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-sm text-primary-200/90 mt-4 flex items-center gap-2">
              <i className="ri-mail-line" /> service@hongtao.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-200/70">
            © 2026 红桃网 hongtao.com 版权所有 · 本站内容均为演示数据
          </p>
          <p className="text-xs text-primary-200/70">
            影视资讯 · 娱乐新闻 · 电影推荐 · 电视剧更新
          </p>
        </div>
      </div>
    </footer>
  );
}